import { render, staticRenderFns } from "./deleted-users.vue?vue&type=template&id=dc5891fe&scoped=true&"
import script from "./deleted-users.vue?vue&type=script&lang=js&"
export * from "./deleted-users.vue?vue&type=script&lang=js&"
import style0 from "./deleted-users.vue?vue&type=style&index=0&id=dc5891fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc5891fe",
  null
  
)

export default component.exports